import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { applyBrandTheme } from "./lib/brand";

// Iframe-breakout (mirrors id-online/main.tsx). The B2C signup journey runs
// inside this SPA's own modal <iframe>; after the adapter's /auth/callback 302s
// the iframe back to onboarding.<root>/?transactionId=…, we'd otherwise render
// the signed-in continuation *inside* the modal iframe instead of as the full
// page. When framed, navigate the outermost frame to the same URL so the
// onboarding continuation becomes the top-level page (and the modal is gone).
if (window.self !== window.top && window.top) {
  window.top.location.replace(window.location.href);
} else {
  applyBrandTheme(); // brand-tint the surface (buttons/avatar) before first paint

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: false, refetchOnWindowFocus: false },
    },
  });

  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("missing #root in index.html");

  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
}
